export default "__VITE_ASSET__DYQWVXq1__"